import { Action } from '@ngrx/store';
import { OrderLoad } from '@ordersnproducts/modules/order-builder/modules/multiple-order-summary/models/orderSummary.model';
import { OrdersConfirmation, OrdersConfirmationStatus, RequestActionModel } from '../models/orderConfirmation.model';
export enum MultipleOrderConfirmationActionTypes {
  START_LOADING = '[Orders Confirmation] Start loading orders',
  REQUEST = '[Orders Confirmation] Request',
  REQUEST_COMPLETE = '[Orders Confirmation] Request complete',
  LOADING_COMPLETE = '[Orders Confirmation] Finish loading orders',
  RESET = '[Orders Confirmation] Reset',
  SET_ORDER_CODE = '[Orders Confirmation] set order code',
  SET_ORDER_CODES = '[Orders Confirmation] set order codes',
  SET_ORDER_ERRORS = '[Orders Confirmation] set order errors',
  SET_BATCH_ID = '[Orders Confirmation] Set orders batch id',
}

export interface IOrderConfirmationData {
  orderId: number;
  orderCode: string;
  orderError: boolean;
  errorMessage: string[];
  hasSpecialBlock: boolean;
  status?: OrdersConfirmationStatus;
}

export class MultipleOrderConfirmationStarLoadAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.START_LOADING;

  constructor() {}
}

export class MultipleOrderConfirmationGetAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.REQUEST;

  constructor(public payload: { orders: RequestActionModel[] }) {}
}

export class MultipleOrderConfirmationLoadCompleteAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.REQUEST_COMPLETE;

  constructor(public payload: { order: OrdersConfirmation; items: OrderLoad[] }[]) {}
}

export class MultipleOrderConfirmationSetBactchIdAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.SET_BATCH_ID;

  constructor(public payload: number) {}
}

export class MultipleOrderConfirmationSetOrderCodeAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.SET_ORDER_CODE;

  constructor(public payload: { orderId: number; orderCode: string; orderError: boolean; errorMessage: string[] }) {}
}

export class MultipleOrderConfirmationSetOrdersCodeAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.SET_ORDER_CODES;

  constructor(public payload: IOrderConfirmationData[]) {}
}

export class MultipleOrderConfirmationSetOrderErrorsAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.SET_ORDER_ERRORS;

  constructor(
    public payload: {
      orderId: number;
      orderCode: string;
      orderError: boolean;
      errorMessage: string[];
      hasSpecialBlock: boolean;
    }[],
  ) {}
}

export class MultipleOrderConfirmationResetAction implements Action {
  readonly type = MultipleOrderConfirmationActionTypes.RESET;

  constructor() {}
}

export type MultipleOrderConfirmationActions =
  | MultipleOrderConfirmationStarLoadAction
  | MultipleOrderConfirmationLoadCompleteAction
  | MultipleOrderConfirmationGetAction
  | MultipleOrderConfirmationResetAction
  | MultipleOrderConfirmationSetBactchIdAction
  | MultipleOrderConfirmationSetOrderCodeAction
  | MultipleOrderConfirmationSetOrderErrorsAction
  | MultipleOrderConfirmationSetOrdersCodeAction;
